export enum DialogWidthSize {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE',
  XLarge = 'XLARGE',
}
